// User Model
import { Model } from '@vuex-orm/core';

export default class CourseCatalogV4 extends Model {
    // This is the name used as module name of the Vuex Store.
    static entity = 'coursecatalogsv4';

    // List of all fields (schema) of the post model. `this.attr` is used
    // for the generic field type. The argument is the default value.
    static fields() {
        return {
            id: this.attr(null),
            name: this.attr(''),
            modules: this.attr([]),
            sales_page: this.attr(''),
            slug: this.attr(''),
            image: this.attr(null),
            numbered: this.attr(false),
            manual_finish: this.attr(false),
        };
    }

    static apiConfig = {
        actions: {
            fetchCourseCatalog(course_slug) {
                return new Promise((resolve, reject) => {
                    this.get(`/api/v4/e-learning/courses/${course_slug}/catalog?include=image`, {
                        dataTransformer: (response) => response.data.data,
                    }).then((response) => {
                        resolve(response);
                    }).catch((err) => {
                        reject(err);
                    });
                });
            },
        },
    };
}

window.CourseCatalogV4 = CourseCatalogV4;
